import { render } from "./MasterDataColumnsForm.vue?vue&type=template&id=1d69f66a&ts=true"
import script from "./MasterDataColumnsForm.vue?vue&type=script&lang=ts"
export * from "./MasterDataColumnsForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__